import {
  MARKETING_LOADING,
  GET_MARKETING,
  GET_MARKETING_SUCCESS,
  GET_MARKETING_FAIL,
  ADD_MARKETING_SUCCESS,
  ADD_MARKETING_FAIL,
  DELETE_MARKETING_SUCCESS,
  DELETE_MARKETING_FAIL,
  UPDATE_MARKETING_SUCCESS,
  UPDATE_MARKETING_FAIL,
  MARKETING_RESET
} from "./actionType";

const INIT_STATE = {
  marketings: [],
  error: {},
};

const Marketing = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MARKETING_SUCCESS:
      switch (action.payload.actionType) {
        case GET_MARKETING:
          return {
            ...state,
            marketings: action.payload.data,
            isMarketingCreated: false,
            isMarketingSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_MARKETING_FAIL:
      switch (action.payload.actionType) {
        case GET_MARKETING_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isMarketingCreated: false,
            isMarketingSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_MARKETING: {
      return {
        ...state,
        isMarketingCreated: false,
        loading: true,
      };
    }

    case MARKETING_LOADING: {
      return {
        ...state,
        isMarketingCreated: false,
        loading: true,
      };
    }

    case ADD_MARKETING_SUCCESS:
      return {
        ...state,
        isMarketingCreated: true,
        loading: false,
        marketings: [action.payload.data, ...state.marketings],
      };

    case ADD_MARKETING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_MARKETING_SUCCESS:
      return {
        ...state,
        loading: false,
        isMarketingCreated: true,
        marketings: state.marketings.filter(
          marketing => marketing.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_MARKETING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_MARKETING_SUCCESS:
      return {
        ...state,
        loading: false,
        isMarketingCreated: true,
        marketings: state.marketings.map(marketing =>
          marketing.id.toString() === action.payload.data.id.toString() ? { ...marketing, ...action.payload.data } : marketing
        ),
      };

    case UPDATE_MARKETING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case MARKETING_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Marketing;